var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var PseudoSelect = function () {
            function PseudoSelect(inputSelector) {
                _classCallCheck(this, PseudoSelect);

                this.input = document.querySelector(inputSelector);
                if (!this.input) {
                    return;
                }

                this.main = this.input.closest('.pseudo-select');
                if (!this.main) {
                    return;
                }

                this.optionsContainer = this.main.querySelector('.options');
                this.checkedClass = 'check';

                this.defaultText = this.main.classList.contains('show-default') ? this.main.getAttribute('data-empty') : '';
                this.options = [];

                this.handlers();
            }

            _createClass(PseudoSelect, [{
                key: "setOption",
                value: function setOption(opt) {
                    if (!opt) {
                        return false;
                    }

                    var ps = opt.closest('.pseudo-select');
                    var parent = opt.parentElement;
                    var label = opt.querySelector('.name');
                    var val = opt.dataset.value;
                    var selWrap = ps.querySelector('.sel_wrap');
                    var input = ps.querySelector('input');

                    selWrap.innerHTML = label ? label.innerHTML : opt.innerHTML;
                    input.setAttribute('value', val);

                    var allItems = parent.querySelectorAll('.item');
                    allItems.forEach(function (item) {
                        item.classList.remove('check');
                    });
                    opt.classList.add('check');

                    return val;
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    this.pseudoSelectToggle();
                    this.pseudoSelectOptionClick();
                    this.pseudoSelectChangeInput();
                }
            }, {
                key: "pseudoSelectToggle",
                value: function pseudoSelectToggle() {
                    var self = this;

                    var select = self.main.querySelector('.select');

                    select.addEventListener('click', function (event) {
                        var target = event.target;
                        var select = target.closest('.pseudo-select');
                        var options = select.querySelector('.options');

                        if (!select.classList.contains('opened')) {
                            select.classList.add('opened');
                            self.fadeIn(options, 'fast');

                            // Добавим обработчик клика, чтобы закрыть .options при клике вне области
                            var closeOptions = function closeOptions(event) {
                                if (!select.contains(event.target)) {
                                    select.classList.remove('opened');
                                    self.fadeOut(options, 'fast');
                                    document.body.removeEventListener('click', closeOptions);
                                }
                            };
                            document.body.addEventListener('click', closeOptions);
                        } else {
                            select.classList.remove('opened');
                            self.fadeOut(options, 'fast');
                        }
                    });
                }
            }, {
                key: "pseudoSelectOptionClick",
                value: function pseudoSelectOptionClick() {
                    var self = this;
                    var items = this.main.querySelectorAll('.options .item');

                    items.forEach(function (item) {
                        item.addEventListener('click', function (event) {
                            var target = event.currentTarget;

                            if (!target.classList.contains('check')) {
                                var select = target.closest('.pseudo-select');
                                var input = select.querySelector('input');

                                input.value = target.dataset.value;
                                self.setOption(select.querySelector('.options .item[data-value="' + input.value + '"]'));
                                input.dispatchEvent(new Event('change'));
                            } else {
                                self.closeOptions(event, target);
                            }
                        });
                    });
                }
            }, {
                key: "pseudoSelectChangeInput",
                value: function pseudoSelectChangeInput() {
                    var self = this;
                    var items = this.main.querySelectorAll('input');

                    items.forEach(function (item) {
                        item.addEventListener('change', function (event) {
                            var target = event.target;

                            var select = target.closest('.pseudo-select');
                            var option = select.querySelector('.options .item[data-value="' + target.value + '"]');

                            if (option) {
                                self.setOption(option);
                            } else {
                                target.value = '';
                                select.querySelector('.sel_wrap').innerHTML = select.getAttribute('data-empty');
                            }

                            self.closeOptions(event, option || select);
                        });
                    });
                }
            }, {
                key: "closeOptions",
                value: function closeOptions(event, element) {
                    if (!element) {
                        return;
                    }

                    var select = element.closest('.pseudo-select');
                    if (!select) {
                        return;
                    }

                    var options = select.querySelector('.options');

                    if (!element.contains(event.target) || event.target.classList.contains('check')) {
                        select.classList.remove('opened');
                        this.fadeOut(options, 'fast');
                        document.body.removeEventListener('click', this.close);
                    }
                }
            }, {
                key: "fadeIn",
                value: function fadeIn(element, duration) {
                    element.style.display = 'block';
                    element.style.transition = 'opacity ' + duration;
                    element.style.opacity = '1';
                }
            }, {
                key: "fadeOut",
                value: function fadeOut(element, duration) {
                    element.style.transition = 'opacity ' + duration;
                    element.style.opacity = '0';
                    setTimeout(function () {
                        element.style.display = 'none';
                    }, parseInt(duration));
                }
            }]);

            return PseudoSelect;
        }();

        window.PseudoSelect = PseudoSelect;
    }, {}] }, {}, [1]);